













import Vue from 'vue';
import { OpenUpdatePlanTypeScreen } from '@/mixins/get-content-mixins';
import SettingWrapper from '../setting-wrapper.component.vue';
import { ExtendMixins } from '@/services';
import { AccountPlanTypeResponseModel } from '@/@types/member';

export default ExtendMixins(
  OpenUpdatePlanTypeScreen,
).extend({
  name: 'ManagePlan',
  props: {
    allowPlanChange: {
      type: Boolean,
      required: true,
    },
    accountId: {
      type: Number,
      required: true,
    },
    productType: {
      type: String,
      required: true,
    },
    planType: {
      type: String,
      required: true,
    },
    hasInvestmentAccount: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    userPlanType(): AccountPlanTypeResponseModel {
      return this.planTypes.find((plan) => {
        return plan.planType.toString() === this.planType.toString();
      });
    },
    planTypes(): AccountPlanTypeResponseModel[] {
      return this.$store.getters.planTypes(this.accountId);
    },
    displayPlanType(): AccountPlanTypeResponseModel {
      return this.planTypes.find((plan) => {
        return plan.planType.toString() === this.planType.toString();
      });
    },
    showCTAButton(): boolean {
      return this.allowPlanChange;
    },
  },
  methods: {
    updatePlanType(): void {
      this.openUpdatePlanTypeScreen({
        accountId: this.accountId,
        planDescription: this.userPlanType ? this.userPlanType.planDescription : '',
        planTypeIsStandard: this.userPlanType ? this.userPlanType.isStandardPlan : true,
        hasInvestmentAccount: this.hasInvestmentAccount,
      });
    },
  },
  components: {
    SettingWrapper,
  },
});
